import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/InspectionServices/Banner'
import ListingInspection from '../Component/InspectionServices/ListingInspection'
import BrandSection from '../Component/HomePage/BrandSection'

function InspectionServices() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <ListingInspection/>
        <BrandSection/>
        <Footer/>
    </div>
  )
}

export default InspectionServices